import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Keyboard, A11y } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./solutionpatternsslider.css";
import { Container } from "react-bootstrap";


function SolutionPatternCard({ pattern }) {
  const { category, title, audience, icon, challenge, whatWeBuild, businessImpact, btnLink, btnText } = pattern;

  return (
    <article className="spc-card">
      <div>
        <p className="spc-card__eyebrow">{category}</p>
        <h3 className="spc-card__title">{title}</h3>
        <p className="spc-card__audience">{audience}</p>
      </div>

      <div className="spc-card__icon" aria-hidden="true">
        <img src={icon} alt={category} />
      </div>

      <dl className="spc-card__meta">
        <div className="spc-card__meta-row">
          <dt>Challenge</dt>
          <dd>{challenge}</dd>
        </div>
        <div className="spc-card__meta-row">
          <dt>What we build</dt>
          <dd>{whatWeBuild}</dd>
        </div>
        <div className="spc-card__meta-row">
          <dt>Business impact</dt>
          <dd>{businessImpact}</dd>
        </div>
      </dl>

      <a
        href={btnLink}
        className="learn-more-button"
      >
         {btnText}
      </a>
    </article>
  );
}

/**
 * SolutionPatternsSlider
 *
 * Reusable, data-driven card carousel. All copy lives in
 * `data/solutionPatterns.json` — to add, remove, or reorder cards,
 * edit that file only; no changes to this component are needed.
 *
 * Props:
 *  - data: optional array to override the bundled JSON (same shape).
 *  - showNavigation: show/hide the prev/next arrows (default: true).
 *  - heading / eyebrow: optional text overrides for the section header.
 */
export default function SolutionPatternsSlider({
  data ,
  showNavigation = false,
  eyebrow = "Selected solution patterns",
  heading = "How AI shows up in day-to-day work",
}) {
  return (
    <section className="spc-section">
        <Container>
      <header className="spc-header">
        <p className="spc-header__eyebrow">{eyebrow}</p>
        <h2 className="spc-header__heading">{heading}</h2>
      </header>

      <Swiper
        modules={[Pagination, Navigation, Keyboard, A11y]}
        pagination={{ clickable: true, el: ".spc-pagination" }}
        navigation={
          showNavigation
            ? { prevEl: ".spc-nav--prev", nextEl: ".spc-nav--next" }
            : false
        }
        keyboard={{ enabled: true }}
        spaceBetween={24}
        slidesPerView={1.1}
        breakpoints={{
          640: { slidesPerView: 1.4, spaceBetween: 10 },
          900: { slidesPerView: 2.2, spaceBetween: 10 },
          1200: { slidesPerView: 2.5, spaceBetween: 10 },
        }}
        className="spc-swiper"
      >
        {data.map((pattern) => (
          <SwiperSlide key={pattern.id} className="spc-slide">
            <SolutionPatternCard pattern={pattern} />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="spc-controls">
        {showNavigation && (
          <button type="button" className="spc-nav spc-nav--prev" aria-label="Previous">
            ‹
          </button>
        )}
        <div className="spc-pagination" />
        {showNavigation && (
          <button type="button" className="spc-nav spc-nav--next" aria-label="Next">
            ›
          </button>
        )}
      </div>
      </Container>
    </section>
  );
}